{
  "name": "dominos",
  "version": "1.0.44",
  "author": "Sterlix GmbH",
  "homepage": "https://smoothr.de/",
  "private": true,
  "description": "Versaille Web App",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve": "ionic serve --ssl --external",
    "build": "ng build",
    "build:production": "ng build --configuration production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "deploy": "",
    "prettier": "npx prettier --write 'src/**/*.{ts,js,css,html,scss,json,md}'",
    "postinstall": "patch-package && husky install",
    "postbuild": "echo \"if you need should be installed in package.json\"",
    "prepare": "husky"
  },
  "dependencies": {
    "@adyen/adyen-web": "^6.40.1",
    "@angular/cdk": "^21.2.11",
    "@angular/common": "^21.2.13",
    "@angular/core": "^21.2.13",
    "@angular/fire": "^21.0.0-rc.0",
    "@angular/forms": "^21.2.13",
    "@angular/material": "^21.2.11",
    "@angular/platform-browser": "^21.2.13",
    "@angular/router": "^21.2.13",
    "@angular/service-worker": "^21.2.13",
    "@capacitor/android": "^7.4.5",
    "@capacitor/app": "7.1.1",
    "@capacitor/browser": "^7.0.5",
    "@capacitor/core": "^7.4.5",
    "@capacitor/geolocation": "^7.1.7",
    "@capacitor/ios": "7.6.6",
    "@capacitor/keyboard": "7.0.4",
    "@capgo/inappbrowser": "^7.29.4",
    "@googlemaps/markerclustererplus": "^1.2.4",
    "@ionic/angular": "^8.7.9",
    "@ionic/core": "^8.7.9",
    "@ngx-translate/core": "17.0.0",
    "@ngx-translate/http-loader": "17.0.0",
    "@sentry/angular": "10.43.0",
    "@sentry/capacitor": "3.2.1",
    "@types/socket.io-client": "^3.0.0",
    "angularx-qrcode": "^21.0.4",
    "axios": "^1.7.7",
    "core-js": "^3.38.1",
    "libphonenumber-js": "^1.12.34",
    "moment": "^2.29.4",
    "ngx-socket-io": "4.10.0",
    "rxjs": "^7.8.2",
    "sass": "^1.89.2",
    "scriptjs": "^2.5.9",
    "socket.io-client": "^4.6.1",
    "swiper": "12.2.0",
    "ts-custom-error": "^3.1.1",
    "tslib": "^2.8.1",
    "validator": "^13.11.0"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2100.4",
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular-devkit/core": "^21.2.11",
    "@angular-devkit/schematics": "^21.2.11",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "^21.2.11",
    "@angular/compiler": "^21.2.13",
    "@angular/compiler-cli": "^21.2.13",
    "@angular/language-service": "^21.2.13",
    "@capacitor/cli": "^7.4.5",
    "@ionic/angular-toolkit": "^12.3.0",
    "@types/google.maps": "^3.65.1",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "eslint": "8.57.1",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jsdoc": "^48.3.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "husky": "^9.1.7",
    "patch-package": "^8.0.1",
    "postinstall-postinstall": "^2.1.0",
    "prettier": "^3.6.2",
    "ts-node": "^10.9.2",
    "typescript": "^5.5.4",
    "zone.js": "^0.15.1"
  }
}
